module.exports = __webpack_public_path__ + "img/emoji_aixin.494625a2.png";